module.exports = __webpack_public_path__ + "img/classic-theme.c16daf6a.jpg";